import { render, staticRenderFns } from "./ModuleTile.vue?vue&type=template&id=5478aaaa&scoped=true"
import script from "./ModuleTile.vue?vue&type=script&lang=js"
export * from "./ModuleTile.vue?vue&type=script&lang=js"
import style0 from "./ModuleTile.vue?vue&type=style&index=0&id=5478aaaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478aaaa",
  null
  
)

export default component.exports